export default "__VITE_ASSET__V5tL7ioL__"